import { useSelector } from 'react-redux';
import MissingGraph from '../../../MissingGraph';
import { GRAPH_STRATEGIES } from '../../../consts';
import { getMetricsGroupByV3 } from '../../../custom-metrics-api.facade';
import { GRAPH_TYPES, METRIC_TYPE } from '../../consts/graphTypes';
import NoDataInfoBox from './NoDataInfoBox';
import getSkeltonByGraphType from './skeletons/widget.skeleton';
import { teamsSelector } from 'state/selectors/teams';
import { getAllTeamsGroupId } from 'common/utils/utils';
import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';

const VALID_CUSTOM_METRICS_SCOPE_FILTERS = ['organization', 'repository'];

const useEmptyStates = ({ loadingMetrics, graph, filters, subtext }) => {
  const teams = useSelector(teamsSelector) || [];

  const { getSettingOrDefinitionValue } = useSettingsService();

  const customStagesForTeamsEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.customStagesForTeamsEnabled
  });
  if (loadingMetrics) {
    const Skelton = getSkeltonByGraphType(
      graph.type ?? GRAPH_TYPES.AREA_SPLINE
    );
    return {
      isEmptyStateMetric: false,
      showNoDataInfoBox: false,
      missingGraphData: false,
      EmptyState: <Skelton />
    };
  }

  let EmptyState = null;

  const allTeamsGroupId = getAllTeamsGroupId(teams);
  const v3GroupBy = getMetricsGroupByV3({ ...filters, allTeamsGroupId });

  const value = subtext;

  const showNoDataInfoBox =
    !loadingMetrics &&
    (!value || value === '-') &&
    graph.metricType === METRIC_TYPE.pm;

  const missingDataOnSelectedFilter =
    !VALID_CUSTOM_METRICS_SCOPE_FILTERS.includes(v3GroupBy.apiParam);

  const missingGraphData =
    missingDataOnSelectedFilter &&
    graph.strategy === GRAPH_STRATEGIES.REPORTED &&
    !customStagesForTeamsEnabled;

  if (showNoDataInfoBox && !loadingMetrics) {
    EmptyState = <NoDataInfoBox />;
  }

  if (missingGraphData) {
    EmptyState = <MissingGraph name={graph.name} />;
  }

  return {
    showNoDataInfoBox,
    missingGraphData,
    EmptyState
  };
};

export default useEmptyStates;
